import React, { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import Icon from './Icon';

interface Props {
    href: string;
    description?: string;
    className?: string;
    children: ReactNode;
}

const ExternalLink = ({ href, description, className, children }: Props) => (
    <a href={href} target="_blank" rel="noreferrer">
        <div
            className={twMerge(
                'flex w-full items-center justify-between rounded-sm p-2 hover:bg-gray-100',
                className,
            )}
        >
            <div>{children}</div>
            <div className="flex items-center gap-x-1">
                <div className="text-sm text-gray-500">{description}</div>
                <Icon iconKey="openInNew" />
            </div>
        </div>
    </a>
);

export default ExternalLink;
